import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconArrowLeft: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="arrow-left"><path d="M10 5.75L3.75 12L10 18.25" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/><path d="M4.5 12H20.25" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/></CentralIconBase>;
};

export default IconArrowLeft;
